'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Banner = exports.More = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    0%, 20%, 50%, 80%, 100% {\n        transform: translateY(0);\n    }\n    40% {\n        transform: translateY(-1em);\n    }\n    60% {\n        transform: translateY(-0.5em);\n    }\n'], ['\n    0%, 20%, 50%, 80%, 100% {\n        transform: translateY(0);\n    }\n    40% {\n        transform: translateY(-1em);\n    }\n    60% {\n        transform: translateY(-0.5em);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: absolute;\n    width: 100px;\n    bottom: 0;\n    left: calc(50% - 50px);\n    text-align: center;\n    font-size: 4em;\n    animation: ', ' 3s infinite;\n'], ['\n    position: absolute;\n    width: 100px;\n    bottom: 0;\n    left: calc(50% - 50px);\n    text-align: center;\n    font-size: 4em;\n    animation: ', ' 3s infinite;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    position: relative;\n    font-size: 1.2em;\n    line-height: 1.4em;\n    min-height: ', 'em;\n    padding: 5em 1em;\n    background-image: url(', ');\n    background-size: cover;\n    background-position: center center;\n    text-shadow: 0 0 9px rgba(0,0,0,0.6);\n'], ['\n    position: relative;\n    font-size: 1.2em;\n    line-height: 1.4em;\n    min-height: ', 'em;\n    padding: 5em 1em;\n    background-image: url(', ');\n    background-size: cover;\n    background-position: center center;\n    text-shadow: 0 0 9px rgba(0,0,0,0.6);\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iosArrowDown = require('react-icons/lib/io/ios-arrow-down');

var _iosArrowDown2 = _interopRequireDefault(_iosArrowDown);

var _Section = require('./Section');

var _SectionTitle = require('./SectionTitle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var bounce = (0, _styledComponents.keyframes)(_templateObject);

var More = exports.More = (0, _styledComponents2.default)(_iosArrowDown2.default)(_templateObject2, bounce);
More.displayName = 'More';
/*::
type Props = {|
    big?: bool,
    className?: string,
    background_url: string,
    title: string,
    children: React.Node,
|}
*/
var Banner /*: ComponentType<Props> */ = (0, _styledComponents2.default)(function (_ref) {
    var _ref$big = _ref.big,
        big = _ref$big === undefined ? false : _ref$big,
        className = _ref.className,
        title = _ref.title,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['big', 'className', 'title', 'children']);

    return React.createElement(
        _Section.Section,
        Object.assign({ className: className }, props, {
            title: React.createElement(_SectionTitle.SectionTitle.h1, { simple: true, dangerouslySetInnerHTML: { __html: title } }),
            dark: true }),
        children,
        big && React.createElement(More, null)
    );
})(_templateObject3, function (props) {
    return props.big ? 30 : 16;
}, function (props) {
    return props.background_url;
});
exports.Banner = Banner;
Banner.displayName = 'Banner';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Banner.js
// module id = 386
// module chunks = 0